import { ApolloClient } from '@apollo/client'
import {
  GetViewUuidsForListNavigationQuery,
  GetViewUuidsForListNavigationQueryVariables,
  ViewType,
} from 'types/graphql'

import { GetViewUuidsForListNavigation } from './getViewUuidsForListNavigationQuery'

/** Fallback when session-only viewUuid was lost (e.g. full page reload). */
export const fetchViewUuidForTasksListNavigation = async ({
  apolloClient,
  organizationId,
  viewId,
}: {
  apolloClient: ApolloClient<object>
  organizationId: number
  viewId: number
}): Promise<string | null> => {
  const result = await apolloClient.query<
    GetViewUuidsForListNavigationQuery,
    GetViewUuidsForListNavigationQueryVariables
  >({
    query: GetViewUuidsForListNavigation,
    variables: {
      input: {
        organizationId,
        viewType: 'RecordTasksForStaffOrgWide' as ViewType,
      },
    },
    fetchPolicy: 'no-cache',
  })

  const views = result.data?.getViews ?? []
  return views.find((view) => view.id === viewId)?.uuid ?? null
}
